import { pushNotificationsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PUSH_NOTIFICATIONS_ACTION_TYPE = createNamedActions('pushNotifications', {
  GET_STATISTICS: 'GET_STATISTICS',
  MARK_ALL_READ_PENDING: 'MARK_ALL_READ_PENDING',
  MARK_ALL_READ_REJECTED: 'MARK_ALL_READ_REJECTED',

  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  NOTIFICATION_RECEIVED: 'NOTIFICATION_RECEIVED',
  MARK_READ_PENDING: 'MARK_READ_PENDING',
  MARK_READ_REJECTED: 'MARK_READ_REJECTED',
  TOGGLE_IMPORTANT_OPTIMISTIC: 'TOGGLE_IMPORTANT_OPTIMISTIC',
  TOGGLE_IMPORTANT_ROLLBACK: 'TOGGLE_IMPORTANT_ROLLBACK',
  SET_CONNECTION_STATUS: 'SET_CONNECTION_STATUS',
  SET_FILTER: 'SET_FILTER',
});

export const fetchNotificationsAction = catchAsyncActionError(
  ({ userId, ...params }) =>
    async dispatch => {
      const { data } = await pushNotificationsApi.getNotifications(userId, params);

      return dispatch({
        type: PUSH_NOTIFICATIONS_ACTION_TYPE.FETCH_NOTIFICATIONS,
        payload: data,
        meta: { isLoadMore: !!params.cursor },
      });
    },
);

export const getPushNotificationsStatisticsAction = catchAsyncActionError(
  ({ userId }) =>
    async dispatch => {
      const { data } = await pushNotificationsApi.getStatistics(userId);

      return dispatch({
        type: PUSH_NOTIFICATIONS_ACTION_TYPE.GET_STATISTICS,
        payload: data,
      });
    },
);

export const notificationReceivedAction = notification => ({
  type: PUSH_NOTIFICATIONS_ACTION_TYPE.NOTIFICATION_RECEIVED,
  payload: notification,
});

export const markReadAction = catchAsyncActionError(
  ({ userId, notificationId }) =>
    async (dispatch, getState) => {
      const { pushNotifications } = getState();
      const item = pushNotifications.items.find(n => n.id === notificationId);
      const previousReadDate = item?.readDate;
      const previousUnreadCount = pushNotifications.unreadCount;

      dispatch({
        type: PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_READ_PENDING,
        payload: { notificationId },
      });

      try {
        await pushNotificationsApi.updateNotification(userId, notificationId, {
          isRead: true,
          isImportant: null,
        });
      } catch (error) {
        dispatch({
          type: PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_READ_REJECTED,
          payload: { notificationId, previousReadDate, previousUnreadCount },
        });

        throw error;
      }
    },
);

export const markAllReadAction = catchAsyncActionError(
  ({ userId }) =>
    async (dispatch, getState) => {
      const { pushNotifications } = getState();
      const previousItems = pushNotifications.items;
      const previousUnreadCount = pushNotifications.unreadCount;

      dispatch({ type: PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_ALL_READ_PENDING });

      try {
        await pushNotificationsApi.markAllAsRead(userId);
      } catch (error) {
        dispatch({
          type: PUSH_NOTIFICATIONS_ACTION_TYPE.MARK_ALL_READ_REJECTED,
          payload: { previousItems, previousUnreadCount },
        });

        throw error;
      }
    },
);

export const setConnectionStatusAction = status => ({
  type: PUSH_NOTIFICATIONS_ACTION_TYPE.SET_CONNECTION_STATUS,
  payload: status,
});

export const toggleImportantAction = catchAsyncActionError(
  ({ userId, notificationId, isImportant }) =>
    async dispatch => {
      dispatch({
        type: PUSH_NOTIFICATIONS_ACTION_TYPE.TOGGLE_IMPORTANT_OPTIMISTIC,
        payload: { notificationId, isImportant },
      });

      try {
        await pushNotificationsApi.updateNotification(userId, notificationId, {
          isRead: null,
          isImportant,
        });
      } catch (error) {
        dispatch({
          type: PUSH_NOTIFICATIONS_ACTION_TYPE.TOGGLE_IMPORTANT_ROLLBACK,
          payload: { notificationId, isImportant: !isImportant },
        });

        throw error;
      }
    },
);

export const setFilterAction = filterUpdate => ({
  type: PUSH_NOTIFICATIONS_ACTION_TYPE.SET_FILTER,
  payload: filterUpdate,
});
